import React, { useState} from 'react'
import moment from 'moment'

import useSWR, { useSWRConfig } from 'swr'
import { Table, Button, Form } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { Navigate } from 'react-router-dom'


import ApiResponseErrorView from '../../api/ApiResponseErrorView.js'
import BigTable from '../../components/BigTable.js'
import ResourceLoader from '../../ResourceLoader.js'
import { resourceHandler } from '../../api/resource.js'
import { requestHandler } from '../../api/request.js'

import '../../BigButton.css'

function CommentHistory(props)
{
    let data = [];
    let datetime_lookup = { }
    for(let i = 0; i < props.data.notes.length; i++)
    {
        let user = props.data.notes[i].user
        for(let j = 0; j < props.data.superusers.length; j++)
        {
            if(props.data.superusers[j].id === user)
            {
                user = props.data.superusers[j].username
                break;
            }
        }
        datetime_lookup[props.data.notes[i].date_created] =
            moment(props.data.notes[i].date_created, 'MMMM Do YYYY - hh:mm:ss A').valueOf();

        let obj = {
            date: moment(props.data.notes[i].date_created + 'Z').format(
                'MMMM Do YYYY - hh:mm:ss A'),
            user: user,
            note: props.data.notes[i].comment
        };

        data.push(obj);
    }

    let headers = [
        { title: "Date", field: "date", width: 3000, minWidth: 200,
            sortable: true, searchable: true, customSort: (a, b) =>
            {
                return datetime_lookup[a] - datetime_lookup[b]
            } },
        { title: "User", field: "user", width: 3000, minWidth: 200,
            sortable: true, searchable: true },
        { title: "Note", field: "note", width: 3000, minWidth: 600,
            sortable: true, searchable: true },
    ];


    return <BigTable
        headers={headers}
        data={data}
        defaultSort={{
            'key': 'column-0',
            'order': 'desc'
        }}
        title={'Edit History'}
    />
}

function CabinetEditForm(props)
{
    const { data: notes, error: note_error } = useSWR(
        resourceHandler.list_cabinet_notes(props.data.cabinet.id).url,
        requestHandler.cacheFetcher);

    let loaded = (notes);
    let error = !(!note_error);

    let original_power = '';
    for(let i = 0; i < props.data.power_boards.length; i++)
    {
        let power_board = props.data.power_boards[i];
        if(power_board.cabinet === props.data.cabinet.id)
        {
            original_power = power_board.id;
        }
    }

    const [serialNumber, setSerialNumber] = useState(props.data.cabinet.serial_no)
    const [truckAssignment, setTruckAssignment] = useState(props.data.cabinet.truck)
    const [powerAssignment, setPowerAssignment] = useState(original_power)
    const [additionalComments, setAdditionalComments] = useState('')

    /*
     * State update callbacks
     */
    const onSerialChange = (event) =>
    {
        setSerialNumber(event.target.value);
    };
    const onTruckAssignment = (event) =>
    {
        setTruckAssignment(event.target.value);
    };
    const onPowerAssignment = (event) =>
    {
        setPowerAssignment(event.target.value);
    }
    const onAdditionalComments = (event) =>
    {
        setAdditionalComments(event.target.value);
    };
    const onEditCabinet = (event) =>
    {
        /*
         * Data checks
         */
        if(!parseInt(serialNumber))
        {
            alert('Serial number needs to be numeric');
            return;
        }
        if(serialNumber.length === 0)
        {
            alert('Serial number needs to be non zero');
            return;
        }
        if(serialNumber !== props.data.cabinet.serial_no)
        {
            for(let i = 0; i < props.data.cabinets.length; i++)
            {
                if(props.data.cabinets[i].serial_no === serialNumber)
                {
                    alert('The serial number you entered is already assigned to a cabinet!');
                    return;
                }
            }
        }

        let edit_post_obj = {
            serial_no: serialNumber,
            truck: truckAssignment,
        }

        if(edit_post_obj.truck === '')
        {
            edit_post_obj.truck = null
        }

        let comment_post_obj = {
            cabinet: props.data.cabinet.id,
            comment: additionalComments,
            user: props.data.company_admin.id
        }


        let power_id = null;
        let old_power_id = null;
        for(let i = 0; i < props.data.power_boards.length; i++)
        {
            let power_board = props.data.power_boards[i]
            if(power_board.cabinet === props.data.cabinet.id)
            {
                old_power_id = power_board.id
            }
        }
        if(powerAssignment !== '')
        {
            power_id = powerAssignment;
        }
        let power_patch_obj = {
            cabinet: props.data.cabinet.id
        };

        props.onSubmit(edit_post_obj, comment_post_obj, power_patch_obj, power_id, old_power_id)
    };

    const truckOptionList = () =>
    {
        let unassigned_truck_list = []

        for(let i = 0; i < props.data.trucks.length; i++)
        {
            let match = false;
            for(let j = 0; j < props.data.cabinets.length; j++)
            {
                if(props.data.cabinets[j].truck === props.data.trucks[i].id)
                {
                    if(props.data.cabinet.truck !== props.data.trucks[i].id)
                    {
                        match = true;
                        break;
                    }
                }
            }

            if(!match)
            {
                unassigned_truck_list.push(props.data.trucks[i]);
            }
        }

        return unassigned_truck_list.map(
            (truck, index) =>
        {
            return (
                <option value={truck.id}>
                    {truck.limntech_name}
                </option>
            );
        });
    }

    const powerOptionList = () =>
    {
        let unassigned_power_list = []
        for(let i = 0; i < props.data.power_boards.length; i++)
        {
            let power_board = props.data.power_boards[i];
            if(power_board.is_broken)
            {
                continue;
            }
            if(power_board.is_deleted)
            {
                continue;
            }
            if(power_board.cabinet !== null)
            {
                if(power_board.cabinet !== props.data.cabinet.id)
                {
                    continue;
                }
            }

            unassigned_power_list.push(power_board);
        }

        return unassigned_power_list.map(
            (pb, idx) =>
        {
            return (
                <option value={pb.id}>
                    {pb.serial_no}
                </option>
            );
        });
    }

    if(error)
    {
        return (
            <ApiResponseErrorView
                error={error}
            />
        );
    }
    else if(loaded)
    {
        let data = props.data;
        data['notes'] = notes;

        return (
            <div>
            <h1> Edit Cabinet </h1>
            <Form.Group>
                <Table hover>
                    <tbody>
                        <tr>
                            <td> Serial Number </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onSerialChange}
                                    value={serialNumber}
                                    placeholder={"enter board's serial number"}
                                    size={"lg"} />
                            </td>
                        </tr>
                        <tr>
                            <td> Truck Assignment </td>
                            <td>
                                <Form.Control
                                    as="select"
                                    onChange={onTruckAssignment}
                                    value={truckAssignment}
                                    size={"lg"}>
                                    <option value={''}> Unassigned </option>
                                    { truckOptionList() }
                                </Form.Control>
                            </td>
                        </tr>
                        <tr>
                            <td> Power Board Assignment </td>
                            <td>
                                <Form.Control
                                    as="select"
                                    onChange={onPowerAssignment}
                                    value={powerAssignment}
                                    size={"lg"}>
                                    <option value={''}> Unassigned </option>
                                    { powerOptionList() }
                                </Form.Control>
                            </td>
                        </tr>
                        <tr>
                            <td> Additional Comments </td>
                            <td>
                                <Form.Control
                                    type="input"
                                    onChange={onAdditionalComments}
                                    value={additionalComments}
                                    placeholder={"This field is optional"}
                                    size={"lg"} />
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Form.Group>
            <p>{'\n\n'}</p>
            <p><b> Note: Editing the hardware assignment in this form may invalidate the configuration file generated by the new truck setup survey </b></p>
            <CommentHistory data={data} />
            <p>{'\n\n'}</p>
            <Button
                variant="primary"
                className="BigButton"
                onClick={onEditCabinet}>
                    { "Edit Cabinet" }
            </Button>
            <p>{'\n\n'}</p>
            </div>
        );
    }
    else
    {
        return <ResourceLoader />
    }
}

export default function CameraEdit(props)
{
    let { id } = useParams();
    const [apiError, setApiError] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [redirectToInventory, setRedirectToInventory] = useState(false);

    const { cache } = useSWRConfig()

    /*
     * Data Loading
     */
    const { data: company_admin, error: ca_error } = useSWR(
        resourceHandler.current_user().url, requestHandler.cacheFetcher);
    const { data: cabinets, error: cabinets_error } = useSWR(
        resourceHandler.list_cabinets('').url, requestHandler.cacheFetcher);
    const { data: power_boards, error: power_board_error } = useSWR(
        resourceHandler.list_power_boards().url, requestHandler.cacheFetcher);
    const { data: trucks, error: truck_error } = useSWR(
        resourceHandler.list_trucks('').url, requestHandler.cacheFetcher);
    const { data: superusers, error: superuser_error } = useSWR(
        resourceHandler.list_superusers().url, requestHandler.cacheFetcher);

    /*
     * Render Logic
     */
    let loaded = (company_admin && cabinets && power_boards && superusers && trucks);
    let error = !(!ca_error && !cabinets_error && !power_board_error && !superuser_error && !truck_error);

    const onRedirectInventory = () =>
    {
        /*
         * Since this is just internal use, I don't want to make the code more
         * complicated to update the cache on these changes. Lets just reload
         * the things we changed here
         */
        cache.delete(resourceHandler.list_trucks('').url)
        cache.delete(resourceHandler.list_power_boards().url)
        setRedirectToInventory(true);
    }
    const onSubmit = (edit_put_obj, comment_post_obj, power_patch_obj, power_id, old_power_id) =>
    {
        const onError = () =>
        {
            setApiError(true);
        }

        const onSuccess = () =>
        {
            setSubmitSuccess(true);
        }
        const assignPowerBoard = (response) =>
        {
            if(power_id === null)
            {
                onSuccess();
            }
            else
            {
                requestHandler.patch(
                    resourceHandler.edit_power_board(power_id),
                    power_patch_obj,
                    onSuccess,
                    onError);
            }
        }
        const clearOldPowerBoard = (response) =>
        {
            if(old_power_id === null)
            {
                assignPowerBoard(null)
            }
            else
            {
                let patch_obj = {
                    cabinet: null
                }

                requestHandler.patch(
                    resourceHandler.edit_power_board(old_power_id),
                    patch_obj,
                    assignPowerBoard,
                    onError);
            }
        }
        const onEditSuccess = (response) =>
        {
            if(comment_post_obj.comment.length === 0)
            {
                clearOldPowerBoard(null);
            }
            else
            {
                requestHandler.post(
                    resourceHandler.create_cabinet_note(),
                    comment_post_obj,
                    clearOldPowerBoard,
                    onError);
            }
        }

        requestHandler.put(
            resourceHandler.edit_cabinet(comment_post_obj.cabinet),
            edit_put_obj,
            onEditSuccess,
            onError);
        setSubmitting(true)
    }

    if(error || apiError)
    {
        return (
            <ApiResponseErrorView
                error={error}
            />
        );
    }
    else if(redirectToInventory)
    {
        return ( <Navigate to="/inventory_management/"/>);
    }
    else if(submitSuccess)
    {
        return (
            <div>
                <h1> Cabinet Edit Success </h1>
                <p> Press the button below to return to inventory </p>
                <p> You may also navigate to any other page using the banner above </p>
                <Button
                    variant="primary"
                    className="BigButton"
                    onClick={onRedirectInventory}>
                        Inventory Management
                </Button>
            </div>
        );
    }
    else if(submitting)
    {
        return <ResourceLoader/>
    }
    else if(loaded)
    {
        let cabinet = null;
        for(let i = 0; i < cabinets.length; i++)
        {
            if(cabinets[i].id === id)
            {
                cabinet = cabinets[i];
                break;
            }
        }

        if(cabinet)
        {
            let data = {
                cabinet: cabinet,
                cabinets: cabinets,
                company_admin: company_admin,
                superusers: superusers,
                trucks: trucks,
                power_boards: power_boards
            };

            return <CabinetEditForm data={data} onSubmit={onSubmit}/>
        }
        else
        {
            return (
                <div>
                <h1> Something went wrong! </h1>
                <p> We could not find a match in the database for the selected cabinet </p>
                </div>
            );
        }
    }
    else
    {
        return <ResourceLoader />
    }
}
